import { render } from "./FoodOrders-detail-next.vue?vue&type=template&id=251ff428"
import script from "./FoodOrders-detail-next.vue?vue&type=script&lang=js"
export * from "./FoodOrders-detail-next.vue?vue&type=script&lang=js"

import "./FoodOrders-detail-next.vue?vue&type=style&index=0&id=251ff428&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__